import classNames from '@prague-digi/class-names'
import React from 'react'
import { BButton } from '@prague-digi/ui-components'

import { intl, IntlInterface } from '../../hoc'
import messages from '../../i18n'
import ControlButtons from '../ControlButtons/ControlButtons'
import styles from './styles.scss'

interface Props extends IntlInterface {
  className?: any
  disableSubmit?: boolean
  forceVerticalViewBreakpoint?: number
  isModal?: boolean
  onSubmit: Function
  secondaryAction?: Function
  secondaryMessage?: any
  submitMessage?: any
  testid?: string
}

export const PageControlButtons = ({
  className,
  disableSubmit,
  forceVerticalViewBreakpoint,
  isModal,
  onSubmit,
  secondaryAction,
  secondaryMessage,
  submitMessage,
  testid,
  translate,
}: Props) => {
  let submitMsg: any = ''
  let secMsg: any = ''

  if (submitMessage) {
    if (typeof submitMessage === 'object' && submitMessage.id) {
      submitMsg = translate(submitMessage)
    } else {
      submitMsg = submitMessage
    }
  } else {
    submitMsg = translate(isModal ? messages.common.save : messages.common.continue)
  }

  if (secondaryMessage) {
    if (typeof secondaryMessage === 'object' && secondaryMessage.id) {
      secMsg = translate(secondaryMessage)
    } else {
      secMsg = secondaryMessage
    }
  } else {
    secMsg = translate(isModal ? messages.common.close : messages.common.back)
  }

  return (
    <ControlButtons
      btnMinWidth={!secondaryAction ? '50%' : undefined}
      btnSameWidthStatic
      className={classNames(styles.pageControlButtons, className)}
      forceVerticalViewBreakpoint={forceVerticalViewBreakpoint}
      revertVerticalOrder>
      {!!secondaryAction && (
        <BButton
          color="secondary"
          messages={{ message: secMsg }}
          onClick={secondaryAction}
          size="lg"
          testid="secondaryActionButton"
          type="button"
        />
      )}

      <BButton
        color="primary"
        disabled={disableSubmit}
        messages={{ message: submitMsg }}
        onClick={onSubmit}
        size="lg"
        testid={testid}
        type="button"
      />
    </ControlButtons>
  )
}

PageControlButtons.defaultProps = {
  forceVerticalViewBreakpoint: 500,
  testid: 'submitButton',
}

export default intl(PageControlButtons)
